module.exports = __webpack_public_path__ + "static/img/00077D_3_R_20200414_fit.a50795a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00077D_3_R_20200414_fit.png
// module id = Qgb3
// module chunks = 0